import isEmpty from "lodash/isEmpty";

import { FiltersV2StoreType } from "./filters_v2_store.types";

export const hasChildrenFiltersSelector = (state: FiltersV2StoreType) => !isEmpty(state.childrenFilters);
export const areBufferedChildrenFiltersOnSelector = (state: FiltersV2StoreType) => state.buffer.areChildrenOn;
